import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_BEGIN,
  DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_FAILURE,
  DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function publishDeploymentSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_BEGIN,
    });
    const { projectId, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/deployment/setting/${uuid}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_SUCCESS,
              data: res,
            });
            Mixpanel.track('Deployment Setting Published', { uuid: uuid });
            toast.success('Published Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_FAILURE,
              data: { error: err },
            });
            Mixpanel.track('Failed to publish deployment setting');
            const errMsg = getErrorMessageFromResponse(res);
            toast.success(`Publish failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissPublishDeploymentSettingError() {
  return {
    type: DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_BEGIN:
      return {
        ...state,
        publishDeploymentSettingPending: true,
        publishDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_SUCCESS:
      return {
        ...state,
        publishDeploymentSettingPending: false,
        publishDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_FAILURE:
      return {
        ...state,
        publishDeploymentSettingPending: false,
        publishDeploymentSettingError: action.data.error,
      };

    case DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_DISMISS_ERROR:
      return {
        ...state,
        publishDeploymentSettingError: null,
      };

    default:
      return state;
  }
}
